import { YoutubeLinkRepository } from '../../domain/repositories/youtube-link.repository.js';
import { YoutubeLinkEntity } from '../../domain/entities/youtube-link.entity.js';

export class ToggleYoutubeLinkStatusUseCase {
  constructor(private readonly repository: YoutubeLinkRepository) {}

  public async execute(id: string, isActive: boolean): Promise<YoutubeLinkEntity> {
    return this.repository.toggleStatus(id, isActive);
  }
}
